// extracted by mini-css-extract-plugin
export default {"wrapper":"_02Delivery_wrapper__wYMAK"};